import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class CurrierPriceService {
  static currierPriceCreate = async (bodyFormData) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/currier-price/create",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static currierPriceDetailsSearch = async (rowsPerPage, page, searchTerm) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/currier-price/search",
        data: {
          filter: [],
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static currierPriceDetailsID = async (priceID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/currier-price/" + priceID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let currierPriceDetailID = response.data.data;

      return currierPriceDetailID;
    } catch (err) {
      throw err;
    }
  };

  static currierPriceDelete = async (priceID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/currier-price/" + priceID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static currierPriceUpdate = async (priceID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/currier-price/update/" + priceID,
        data: bodydata,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

}
